import { css } from "@emotion/css";
import { ListBox, ListBoxProps } from "react-aria-components";

interface Props<T> extends ListBoxProps<T> {}

export function PickerListBox<T extends object>(props: Props<T>) {
  return <ListBox className={styles.content} {...props} />;
}

const styles = {
  content: css({
    flex: 1,
    padding: "var(--space-1)",
  }),
};
